// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Unicred_containerPrincipal__V7ixI","divPrincipal":"Unicred_divPrincipal__LTkAX","divTextos":"Unicred_divTextos__4Sn4y"};